import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import HelpCenterSearch from '../helpCenterSearch/helpCenterSearch';
import styles from './helpCenterSearchBlock.module.scss';
import useWindowDimensions from '../../hooks/useWindowDimensions';

function HelpCenterSearchBlock({
  headline = 'Search for More Topics',
  placeholder = 'Type a question or search keyword',
  placeholderMobile = 'Try search "Deposits"',
}) {
  const searchRef = useRef();
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);
  const placeholderText = isMobile ? placeholderMobile : placeholder;

  const clearSearch = (e, setSearchTerm) => {
    setSearchTerm('');
  };

  return (
    <div className={styles.search}>
      <h2 className={styles.title}>{headline}</h2>
      <div className={styles.searchBox}>
        <HelpCenterSearch
          placeholder={placeholderText}
          onIconClick={clearSearch}
          data-testid="search-input"
          ref={searchRef}
          onEnter={(query) => {
            window.location.assign(`/help/search?query=${query}`);
          }}
        />
      </div>
    </div>
  );
}

HelpCenterSearchBlock.propTypes = {
  headline: PropTypes.string,
  placeholder: PropTypes.string,
  placeholderMobile: PropTypes.string,
};

export default HelpCenterSearchBlock;
